'use strict';

(function (angular) {
    angular
        .module('jwsdw.util')
        .directive('focusTracker', focusTracker);

    /**
     * @class jwsdwUtil.focusTracker
     * @description Initializes focus tracking for specific elements
     */
    function focusTracker() {
        var directive = {
            'restrict': 'A',
            'scope': {
                'focusTracker': '=',
                'focusKey': '@'
            },
            'link': trackFocus
        };

        return directive;

        /**
         * @description Method to track focus of certain focusable elements so that they can manually be focused later on.
         * @param {Object} scope - scope of the directive
         * @param {Object} element - representation of the focusable html element that uses the directive
         * @returns {void}
         */
        function trackFocus(scope, element) {
            element.on('click', function () {
                scope.$apply(function () {
                    scope.focusTracker.set(scope.focusKey, element[0]);
                });
            });
        }
    }
}(angular));